import { createSelector } from 'reselect';

const selectCache = (state: any) => state.OrganisationUserCache;

export const selectLoadingOrgUsers = createSelector(
  selectCache,
  (cache: any) => cache.loadingUsers
);
export const selectIsSubmitting = createSelector(
  selectCache,
  (cache: any) => cache.submitting
);

export const selectErrorMessage = createSelector(
  selectCache,
  (cache: any) => cache.errors
);

export const selectUsers = createSelector(
  selectCache,
  (cache: any) => cache.users
);

export const selectIsModalOpen = createSelector(
  selectCache,
  (cache: any) => cache.isModelOpen
);

export const selectIsSuccess = createSelector(
  selectCache,
  (cache: any) => cache.success
);

export const selectUserAdded = createSelector(
  selectCache,
  (cache: any) => cache.userAdded
);

export const selectUserDeleted = createSelector(
  selectCache,
  (cache: any) => cache.userDeleted
);
